import ReactDOM from "react-dom/client";
import { HashRouter, Route, Routes, Navigate } from "react-router-dom";
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss?v=1.4.0";
import "assets/demo/demo.css?v=1.4.0";
import "assets/demo/nucleo-icons-page-styles.css?v=1.4.0";
import 'react-tooltip/dist/react-tooltip.css';
import 'semantic-ui-css/semantic.min.css';
import StoreComponent from './components/Common/StoreComponent';
import { Suspense, lazy } from "react";

const Index = lazy(() => import("views/Index.js"));
const Newbietips = lazy(() => import("views/Newbietips.js"));
const Newbguide = lazy(() => import("views/Newbguide.js"));
const Pvpguide = lazy(() => import("views/Pvpguide.js"));
const Fleetmaker = lazy(() => import("views/Fleetmaker.js"));
const Contributors = lazy(() => import("views/Contributors.js"));
const Changelogs = lazy(() => import("views/Changelogs.js"));
const Guidelines = lazy(() => import("views/Guidelines.js"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <StoreComponent />
    <Suspense fallback={<div className="ectl-primary" style={{width: "100vw", height: "100vh"}}></div>}>
      <HashRouter>
        <Routes>
          <Route path="/home" element={<Index/>} />
          <Route path="/main/*" element={<Index/>} />
          <Route path="/newbietips/*" element={<Newbietips/>} />
          <Route path="/newbguide/*" element={<Newbguide/>} />
          <Route path="/pvpguide" element={<Pvpguide/>} />
          <Route path="/fleetmaker" element={<Fleetmaker/>} />
          <Route path="/contributors" element={<Contributors/>} />
          <Route path="/changelogs" element={<Changelogs/>} />
          <Route path="/guidelines" element={<Guidelines/>} />
          <Route path="/" element={<Navigate to="/home" replace/>} />
          <Route path="/index" element={<Navigate to="/home" replace/>} />
        </Routes>
      </HashRouter>
    </Suspense>
  </>
);

console.log("Moshi moshi. What could you be looking for?");
